var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Form } from 'antd';
import { FormItemDeepProvider } from '../context';
import { normalizeCol, isAntdV4 } from '../shared';
import { PreviewText } from '@formily/react-shared-components';
export var AntdSchemaFormAdaptor = function (props) {
    var inline = props.inline, previewPlaceholder = props.previewPlaceholder, onSubmit = props.onSubmit, onReset = props.onReset, rest = __rest(props, ["inline", "previewPlaceholder", "onSubmit", "onReset"]);
    return (React.createElement(FormItemDeepProvider, __assign({}, props),
        React.createElement(PreviewText.ConfigProvider, { value: props },
            React.createElement(Form, __assign({}, rest, { labelCol: normalizeCol(props.labelCol), wrapperCol: normalizeCol(props.wrapperCol), layout: inline ? 'inline' : props.layout, onSubmit: onSubmit, onReset: onReset, component: useMemo(function () {
                    if (isAntdV4) {
                        return function (innerProps) {
                            return React.createElement('form', __assign(__assign({}, innerProps), { onSubmit: onSubmit,
                                onReset: onReset }));
                        };
                    }
                }, []) })))));
};
